const firebaseConfig = {
    apiKey: "AIzaSyC0DDBC3RYYC-LaxjLeIAc1EBBzTrcW10g",
    authDomain: "container-relocate.firebaseapp.com",
    databaseURL: "https://container-relocate-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "container-relocate",
    storageBucket: "container-relocate.appspot.com",
    messagingSenderId: "616341147111",
    appId: "1:616341147111:web:aa738171ecc2a140310142"
};

export default firebaseConfig;